import { gql, useQuery } from '@apollo/client';
import { getEapServices } from './__generated__/getEapServices';

export const GET_EAP_SERVICES = gql`
  query getEapServices {
    helpEAPServices {
      id
      serviceName
      description
      icon
    }
  }
`;

export const useGetEapServices = () => {
  const { data, loading, error, refetch } = useQuery<getEapServices>(
    GET_EAP_SERVICES,
    {
      errorPolicy: 'all',
      returnPartialData: false,
    },
  );

  // Sort the services so that the immediate support service (for all EAP providers) is always at the end
  const sortedServices = [...(data?.helpEAPServices ?? [])].sort((a, b) => {
    if (a.icon === 'immediate-support') return 1;
    if (b.icon === 'immediate-support') return -1;

    return 0;
  });

  return {
    data: { helpEAPServices: sortedServices },
    loading,
    error,
    refetch,
  };
};
